import React,{ Component } from 'react'
import { MDBContainer ,MDBView,MDBMask,MDBCol, MDBRow,MDBBtn,MDBIcon,MDBInput, MDBCard,MDBCardHeader, MDBCardBody, MDBCardTitle, MDBCardFooter, MDBCardImage} from 'mdbreact'
import './login.css'
import { connect } from 'react-redux';
import {  signIn } from '../../../store/actions/auth/authActions'
import { Redirect } from 'react-router-dom'
import firebase from 'firebase'
import { styled } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import LoginImg from '../../../assests/images/login.png'
import { useMediaQuery } from '@material-ui/core';


  
  class login extends Component {
    constructor(props) {
      super(props)
  
      this.state = {
             email : '',
             password : '',
             show: false,
             setShow:false
      }
  }

  handleChange = (e) => {
      console.log(e)
      this.setState({
          [e.target.id] : e.target.value
      })
  }
 
  handleSubmit = (e) => {
      console.log("handling")
     e.preventDefault();
    this.props.signIn(this.state)
 }
 
 signInHandler =()=>{
  if (!firebase.auth().currentUser) {
      // [START createprovider]
      var provider = new firebase.auth.GoogleAuthProvider();
      // [END createprovider]
      // [START addscopes]
      provider.addScope('https://www.googleapis.com/auth/contacts.readonly');
      // [END addscopes]
      // [START signin]
      firebase.auth().signInWithPopup(provider).then(function(result) {
        // This gives you a Google Access Token. You can use it to access the Google API.
        var token = result.credential.accessToken;
        // The signed-in user info.
        var user = result.user;
        // [START_EXCLUDE]
        document.getElementById('quickstart-oauthtoken').textContent = token;
        // [END_EXCLUDE]
      }).catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        // The email of the user's account used.
        var email = error.email;
        // The firebase.auth.AuthCredential type that was used.
        var credential = error.credential;
        // [START_EXCLUDE]
        if (errorCode === 'auth/account-exists-with-different-credential') {
          alert('You have already signed up with a different auth provider for that email.');
          // If you are using multiple auth providers on your app you should handle linking
          // the user's accounts here.
        } else {
          console.error(error);
        }
        // [END_EXCLUDE]
      });
      // [END signin]
    } else {
      // [START signout]
      firebase.auth().signOut();
      // [END signout]
    }
}


   render(){
    const { authError, auth } = this.props
    if(auth.uid) return <Redirect to='/' />
      return(
        <div>
        <section
         
        >
        <MDBView>
        <img
          src="https://mdbootstrap.com/img/new/fluid/city/008.jpg"
          className=""
          alt=""
        />
        <section  className="text-center"> 
            
                              <MDBMask overlay="blue-strong">
                                 <MDBRow className="m-5 p-4">
                                 <MDBCol sm="12" xs="">

                                 </MDBCol>
                                 </MDBRow>
                                <MDBRow className="p-3 my-5"
                                 style={{
                                   
                                 }}>
                           
                                    <MDBCol md="6" sm="12" className="m-md-n5 text-center">
                                      <img src={LoginImg} hover="true" className="img-fluid p-sm-5 m-md-n5"/ >
                                    
                                    </MDBCol>
                                   
                                    <MDBCol md="6" sm="12" className="p-2 text-center">
                               
                                    <br />
                                <MDBCard className="p-5" >
                                <MDBCardHeader className="form-header deep-blue-gradient rounded " style={{marginTop: "-4.13rem"}}>
                                      <h4 className="my-2 text-center ">
                                        <MDBIcon icon="lock" className="" /> Login
                                      </h4>
                                    </MDBCardHeader>
                                    <MDBCardBody>
                                    <form  onSubmit={this.handleSubmit}>
                            
                                      <div className="grey-text">
                                      <MDBInput label="email"   group type="email" id="email" onChange={this.handleChange} validate error="wrong"
                                          dark="right" />
                                          <MDBInput label=" password"  group type="password"  id="password" onChange={this.handleChange} validate error="wrong"
                                          success="right"/>
                                          
                                      </div>
                                      <div className="text-center">
                                          <MDBBtn  rounded color="blue" style={{borderRadius:"25px"}} type="submit">
                                          login
                                          <MDBIcon far icon="paper-plane" className="ml-1" />
                                          </MDBBtn>
                                          <MDBBtn  rounded color="blue" style={{borderRadius:"25px"}}  onClick={this.signInHandler}>
                                          sign in
                                          <MDBIcon fab icon="google" className="ml-2" />
                                          </MDBBtn>
                                      </div>
                                     
                                          </form>   
                                      <hr />
                                        <center>
                                        
                                      </center>   
                                      
                                    </MDBCardBody>
                                    <MDBCardFooter className="bg-white">
                                      
                                      <p>Forgot Username / Password? </p>
                                      <div className="red-text center">
                        { authError ? <p>{authError} </p> :null }
                                   </div>
                                    </MDBCardFooter>
                              </MDBCard>
                            
                               
                              </MDBCol>
                                </MDBRow>
                              </MDBMask>
                            </section>
                            </MDBView>

                </section>
              
              
            </div>

      )

 }
 }
    


 const mapStateToProps=(state)=>{
 return{
     authError : state.auth.authError,
     auth : state.firebase.auth
 }
}


const mapDispatchToProps= (dispatch) =>
{
return {
    signIn : (creds) => dispatch(signIn(creds))
}
}



export default connect(mapStateToProps,mapDispatchToProps)(login)